export function scrollbarWidth() {
	// Create a temporary div
	const scrollDiv = document.createElement('div')
	scrollDiv.style.width = '100px'
	scrollDiv.style.height = '100px'
	scrollDiv.style.overflow = 'scroll'
	scrollDiv.style.position = 'absolute'
	scrollDiv.style.top = '-9999px'
	document.body.appendChild(scrollDiv)

	// Calculate scrollbar width
	const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth

	// Remove temporary div
	document.body.removeChild(scrollDiv)

	// Set CSS variable on html
	document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`)
}
